import { ApiResponse } from "@api/apiRequest";
import { tpApi } from "@api/instances";
import rollbar, { LogMetadata } from "@utils/rollbar";

const enableZuoraSubscriptionAutoRenewal = async (subscriptionId: string): Promise<ApiResponse<void>> => {
  try {
    await tpApi.put(
      `/billing/v1/subscriptions/zuora/${subscriptionId}/renew`,
      undefined,
      { requireAuth: true }
    );
    return { data: null, success: true, error: "" };
  } catch (e) {
    const err = e instanceof Error ? e : new Error("Unknown error");
    const meta: LogMetadata = { endpoint: "/billing/v1/subscriptions/zuora/:id/renew", method: "PUT", subscriptionId };
    rollbar.error(err, meta);
    return { data: null, success: false, error: "Error enabling auto-renewal" };
  }
};

export default enableZuoraSubscriptionAutoRenewal;
